import { useCreditsStore, selectLowBalanceNoticePending } from '../state/creditsStore';

// ════════════════════════════════════════════════════════════════════════════
// LowBalanceNotice — pure renderer of the low-balance crossing edge (F3).
// Fires ONCE per (uninitialized|ok) → low crossing (the store increments
// lowBalanceCrossings only on the edge, never per settle event) and stays until
// the user dismisses it (acknowledgeLowBalance records the crossing as seen).
// Email is DEFERRED — this is the in-app notice only. Reuses the app toast look.
// ════════════════════════════════════════════════════════════════════════════

export function LowBalanceNotice() {
  const pending = useCreditsStore(selectLowBalanceNoticePending);
  const acknowledge = useCreditsStore((s) => s.acknowledgeLowBalance);
  const openTopUpModal = useCreditsStore((s) => s.openTopUpModal);

  if (!pending) return null;

  return (
    <div class="low-balance-notice" role="status" aria-live="polite">
      <span class="low-balance-notice__text">Your credits are running low.</span>
      <button
        class="low-balance-notice__action"
        type="button"
        onClick={() => {
          acknowledge();
          openTopUpModal(null);
        }}
      >
        Top up
      </button>
      <button
        class="low-balance-notice__dismiss"
        type="button"
        aria-label="Dismiss"
        onClick={acknowledge}
      >
        ×
      </button>
    </div>
  );
}
